var map = {
	"./bmp": 874,
	"./bmp.js": 874,
	"./gif": 875,
	"./gif.js": 875,
	"./jpg": 876,
	"./jpg.js": 876,
	"./png": 877,
	"./png.js": 877,
	"./psd": 878,
	"./psd.js": 878,
	"./svg": 879,
	"./svg.js": 879,
	"./tiff": 880,
	"./tiff.js": 880,
	"./webp": 881,
	"./webp.js": 881
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 872;


//////////////////
// WEBPACK FOOTER
// ./~/markdown-it-imsize/lib/imsize/types ^\.\/.*$
// module id = 872
// module chunks = 1